module.exports = __webpack_public_path__ + "static/media/not_yet_published_icon.240afdf7.svg";